import React, { useState } from 'react';
import { useGetUsersOfResource } from '../../../api/queries/useGetUsersOfResource';
import { Sorting } from '../../../types/Sorting';
import { DEFAULT_SORT_DIRECTION, DEFAULT_SORT_FIELD } from '../applications/consts';
import { UserFilters } from '../../../types/UserFilters';
import { useGetUsersOfResourceReport } from '../../../api/queries/useGetUsersOfResourceReport';
import { UsersView } from '../users/UsersView';
import { UsersViewRenderMode } from '../users/UsersViewRenderMode';

export const ResourceDetailsDrawer = ({ resource }) => {
    const [filters, setFilters] = useState<UserFilters>({});
    const [sorting, setSorting] = useState<Sorting>({
        direction: DEFAULT_SORT_DIRECTION,
        field: DEFAULT_SORT_FIELD
    });

    const { fetchMoreUsers, users, usersLoading } = useGetUsersOfResource(resource.resource_id, filters, sorting);
    const { downloadReport, downloadingReport } = useGetUsersOfResourceReport(resource.resource_id, filters);

    return (
        <UsersView
            downloadReport={downloadReport}
            downloading={downloadingReport}
            fetchMore={fetchMoreUsers}
            loading={usersLoading}
            renderMode={UsersViewRenderMode.BASIC}
            setFilters={setFilters}
            setSorting={setSorting}
            users={users}
        />
    );
};
